import { trackShareEvent } from '@anm/analytic';
import Button from '@anm/components/buttons/Button';
import IconButton from '@anm/components/buttons/IconButton';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { FC } from 'react';

import withAppMeta, { WithAppMetaProps } from '../../HOCs/withAppMeta';
import routes from '../../routes';

import {
  ShareLinkButtonDifferentOnMobile,
  WaveEventButtonContainer,
  WaveEventButtonContainerBottom
} from './Wrapper';

type HOCs = WithAppMetaProps;

export type WaveEventButtonsProps = {
  onBack: () => void;
};

const { Link } = routes;

const WaveEventButtons: FC<WaveEventButtonsProps & HOCs> = ({
  appMeta: { path },
  onBack
}) => (
  <WaveEventButtonContainer>
    {/*<WaveEventButtonContainerTop>
           <ShowOnMobileButtonsWrapper>
            <Button size="large" variant="light-blue-lowercase">
              Send me a Link to This Event
            </Button>
          </ShowOnMobileButtonsWrapper>
        </WaveEventButtonContainerTop>*/}

    <WaveEventButtonContainerBottom>
      {isMobileOrIPad() ? (
        <IconButton
          size="large"
          variant="white-blue-border-back"
          icon="images/arrow_left_blue.svg"
          onClick={onBack}
        >
          Back
        </IconButton>
      ) : (
        <Link route="video-templates">
          <Button size="large_long" variant="light-blue-lowercase">
            Start Creating
          </Button>
        </Link>
      )}
      <ShareLinkButtonDifferentOnMobile link={path} onShare={trackShareEvent} />
    </WaveEventButtonContainerBottom>
  </WaveEventButtonContainer>
);

export default withAppMeta(WaveEventButtons);
